import { useCurrencies } from 'hooks/useCurrencies'
import React from 'react'

import { cdnBaseUrl } from 'services/cdn'
import { isFiatCurrency } from 'utils/currencies'

export type ICurrencyIconSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl'

interface CurrencyIconProps {
    code: string | null;
    size?: ICurrencyIconSize
    testID?: string;
    style?: any;
}

export const CurrencyIcon: React.FC<CurrencyIconProps> = ({
    code,
    size,
    testID,
    style
}) => {
    const currencies = useCurrencies();

    if (code === null) return null;

    const isFiat = isFiatCurrency(code?.toUpperCase())

    const fiatUrl = `${cdnBaseUrl}assets/currencies/flags/square/${code?.toLowerCase?.()}.svg`
    const cryptoUrl = `${cdnBaseUrl}assets/products/trade/${code?.toLowerCase?.()}.svg`

    const getSize = () => {
        switch (size) {
            case 'xs':
                return '1rem';
            case 'sm':
                return '1.5rem';
            case 'md':
                return '2rem';
            case 'lg':
                return '3rem';
            case 'xl':
                return '4rem';
            case '2xl':
                return '5rem'
            case '3xl':
                return '6rem'
        }
    }

    return (
        <div data-testid={`${testID}:${code}`} style={{
            width: getSize(),
            height: getSize(),
            borderRadius: '10rem',
            backgroundColor: isFiat
                ? 'transparent'
                : currencies?.[code?.toUpperCase?.()]?.colors?.primary,
            color: '#fff',
            ...style
        }}>
            <img
                alt={code}
                style={{
                    width: getSize(),
                    height: getSize(),
                    borderRadius: '10rem'
                }}
                src={isFiat ? fiatUrl : cryptoUrl}
            />
        </div>)
}

CurrencyIcon.defaultProps = {
    size: 'sm',
    testID: 'icon:currency'
}

export default CurrencyIcon;
